export default __webpack_public_path__ + "static/view_02-25_3-48c89dc2085f71f440f48b14cba39e9b.jpg";